import { scopes } from "./scripts-scopes-screen.js";
import { regular } from "./scripts-regular-screen.js";

export default {
	scopes,
	regular
}